'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import { CIRRUS } from 'HubStyleTokens/colors';
import ConsentPrompt from 'conversations-visitor-experience-components/visitor-widget/ConsentPrompt';
import ChatAreaAlert from 'conversations-visitor-experience-components/visitor-widget/ChatAreaAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsPortal53 } from '../../widget-data/operators/getIsPortal53';
import { isOneOfTargetedProductPages } from '../../query-params/getIsOneOfTargetedProductPages';
import { jsx as _jsx } from "react/jsx-runtime";
const ConsentPromptWrapper = styled.div.withConfig({
  displayName: "ProcessConsentPrompt__ConsentPromptWrapper",
  componentId: "s2qyig-0"
})(["border-top:2px solid ", ";"], CIRRUS);
class ProcessConsentPrompt extends Component {
  componentDidMount() {
    const {
      trackInteraction
    } = this.props;
    trackInteraction('widget-interaction', {
      action: 'view consent to process'
    });
  }
  render() {
    const {
      coloring,
      consentToProcess,
      closeConsentToProcess,
      consentToProcessError,
      consentToProcessMessage,
      dismissConsentToProcessError,
      showGdprConsentToProcessButton
    } = this.props;
    return /*#__PURE__*/_jsx(ConsentPromptWrapper, {
      children: consentToProcessError ? /*#__PURE__*/_jsx(ChatAreaAlert, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.network.offline.title"
        }),
        onClose: dismissConsentToProcessError
      }) : /*#__PURE__*/_jsx(ConsentPrompt, {
        showButton: showGdprConsentToProcessButton,
        message: consentToProcessMessage,
        onClick: consentToProcess,
        onClose: closeConsentToProcess,
        coloring: coloring,
        isOneOfTargetedProductPages: isOneOfTargetedProductPages(),
        isPortal53: getIsPortal53()
      })
    });
  }
}
ProcessConsentPrompt.displayName = 'ProcessConsentPrompt';
ProcessConsentPrompt.propTypes = {
  closeConsentToProcess: PropTypes.func,
  coloring: PropTypes.object,
  consentToProcess: PropTypes.func,
  consentToProcessError: PropTypes.bool,
  consentToProcessMessage: PropTypes.string,
  dismissConsentToProcessError: PropTypes.func,
  showGdprConsentToProcessButton: PropTypes.bool,
  trackInteraction: PropTypes.func
};
export default ProcessConsentPrompt;